/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import {
  setExpiredInsuranceList,
  setExpiredInsuranceListLoader,
} from '../../../../infra/aggregates/myProfile/insuranceAggregates/expiredInsuranceSlice';
import { insuranceServices } from '../../../../api/services/insuranceServices';

interface PropsValues {
  setExpiredInsurancesData: (data: any) => void;
}

function DTOExpiredInsurance({ setExpiredInsurancesData }: PropsValues) {
  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state.authSlice);
  const storeExpiredInsurances = useAppSelector(
    (state) => state.expiredInsuranceSlice.expiredInsurance,
  );
  async function getAllExpiredInsurances(empId: number) {
    dispatch(setExpiredInsuranceListLoader(true));
    const response = await insuranceServices.getExpiredInsurance(empId);
    if (response) {
      dispatch(setExpiredInsuranceList(response?.data));
      setExpiredInsurancesData(response?.data);
      dispatch(setExpiredInsuranceListLoader(false));
    } else {
      dispatch(setExpiredInsuranceListLoader(false));
      return;
    }
  }
  useEffect(() => {
    if (selector.emp_id) getAllExpiredInsurances(selector.emp_id);
  }, []);

  useEffect(() => {
    setExpiredInsurancesData(storeExpiredInsurances);
  }, [storeExpiredInsurances]);

  return <></>;
}
export default DTOExpiredInsurance;
